import { defineStore } from 'pinia'
import { ref, reactive, computed } from '@nuxtjs/composition-api'
import {
  ITips,
  IChangeTipsPayload,
  IPayload,
  changeDefaultTips,
  IData
} from './types'

export const useTipsModel = defineStore('tips', () => {
  const tipsUrl = ref<string | null>(null)
  const tab = ref<string>('waiter')
  const tips = reactive<ITips>({
    waiter: {
      label: 'Официант',
      name: '',
      avatar: null,
      purpose: null,
      percents: [0, 10, 15, 20, 25],
      selectedPercent: 0,
      manualTips: false,
      sum: 0,
      active: false,
      errorTips: false,
      hideActiveStylePercent: false
    },
    hookah: {
      label: 'Кальянщик',
      name: '',
      avatar: null,
      purpose: null,
      percents: [0, 5, 10, 15],
      selectedPercent: 0,
      manualTips: false,
      sum: 0,
      active: false
    },
    kitchener: {
      label: 'Кухня',
      name: '',
      avatar: null,
      purpose: null,
      percents: [0, 5, 10, 15],
      selectedPercent: 0,
      manualTips: false,
      sum: 0,
      active: false
    },
    barman: {
      label: 'Бармен',
      name: '',
      avatar: null,
      purpose: null,
      percents: [0, 5, 10, 15],
      selectedPercent: 0,
      manualTips: false,
      sum: 0,
      active: false
    },
    barista: {
      label: 'Бариста',
      name: '',
      avatar: null,
      purpose: null,
      percents: [0, 5, 10, 15],
      selectedPercent: 0,
      manualTips: false,
      sum: 0,
      active: false
    },
    sommelier: {
      label: 'Сомелье',
      name: '',
      avatar: null,
      purpose: null,
      percents: [0, 5, 10, 15],
      selectedPercent: 0,
      manualTips: false,
      sum: 0,
      active: false
    },
    team: {
      label: 'Команда заведения',
      name: 'Команда',
      avatar: null,
      purpose: null,
      percents: [0, 10, 15, 20, 25],
      selectedPercent: 0,
      manualTips: false,
      sum: 0,
      active: false
    }
  })

  // Computed
  const tipsSum = computed(() => {
    const sum = Object.keys(tips).reduce((sum, key) => {
      const res = parseFloat((sum + tips[key].sum).toFixed(2))
      return res
    }, 0)
    return sum
  })

  const tipsError = computed(() => {
    return tips.waiter.sum < 49 && tips.waiter.sum > 0
  })

  const countActiveElements = computed(() => {
    const arrayActiveElements = Object.keys(tips).filter(i => tips[i].active)
    return arrayActiveElements.length
  })

  // Methods
  const changeTab = (tabValue: string) => {
    tab.value = tabValue
  }

  const firstRecountWaiterTips = (payload: IPayload) => {
    const {
      percentRest,
      percentRestZero,
      percentRestFive,
      percentRestTwenty,
      data,
      restCode,
      percentKitchenFive
    } = payload

    // Дефолтные чаевые
    let numberPercents = 10
    if (percentRest) {
      numberPercents = 15
    }
    if (percentRestZero) {
      numberPercents = 0
    }
    if (percentRestFive) {
      numberPercents = 5
    }
    if (percentRestTwenty) {
      numberPercents = 20
    }
    if (percentKitchenFive) {
      tips.kitchener.selectedPercent = 5
      tips.kitchener.sum = Math.round(data.sumorders / 100 * 5)
    }

    if (tips.waiter.active && data.waiter.card_verification && data.tipsType === 'TAPPER') {
      const waiterTips = {
        role: 'waiter',
        percents: [0, 10, 15, 20, 25],
        sum: 49,
        selectedPercent: numberPercents,
        manualTips: false,
        hideActiveStylePercent: true
      }
      if (data.fee_type === 'WITHOUT_FEE') {
        waiterTips.selectedPercent = 12.5
        if (data.sumorders >= 392) {
          waiterTips.sum = (data.sumorders / 100 * 12.5)
          waiterTips.hideActiveStylePercent = false
        }
      } else if (data.sumorders >= 490) {
        waiterTips.sum = (data.sumorders / 100 * numberPercents)
        waiterTips.hideActiveStylePercent = false
      }

      // Новая логика для чаевых
      // if (!newLogic) {
      //   if (data.sumorders <= 500) {
      //     waiterTips.sum = 100
      //     waiterTips.hideActiveStylePercent = true
      //   } else if (data.sumorders > 500 && data.sumorders <= 1000) {
      //     waiterTips.sum = 200
      //     waiterTips.hideActiveStylePercent = true
      //   }
      // }

      // logic for 0% defaule
      if (numberPercents === 0) {
        waiterTips.sum = 0
        waiterTips.hideActiveStylePercent = false
      }

      // if (restCode === 'shota-14154') {
      //   waiterTips.percents = [8, 10, 12, 15, 20]
      //   waiterTips.selectedPercent = 15
      //   waiterTips.sum = (data.sumorders / 100 * 15) > 49 ? (data.sumorders / 100 * 15) : 49
      // }

      if (restCode === 'sirovarnya-17985') {
        waiterTips.percents = [13, 17, 20, 25, 30]
        waiterTips.selectedPercent = 13
        waiterTips.sum = (data.sumorders / 100 * 13) > 49 ? (data.sumorders / 100 * 13) : 49
      }

      if (percentRestFive) {
        waiterTips.sum = (data.sumorders / 100 * 5) > 49 ? (data.sumorders / 100 * 5) : 49
      }

      if (percentRestTwenty) {
        waiterTips.sum = (data.sumorders / 100 * 20) > 49 ? (data.sumorders / 100 * 20) : 49
      }

      changeTips(waiterTips)
    }
  }

  const changeTipsPersonal = (payload: IPayload) => {
    // Обновляем данные персонала
    updateData(payload.data)

    // Делаем активный таб
    if (payload.data.waiter && payload.data.waiter.waiter_status === 'VERIFIED' && (payload.data.waiter.name || payload.data.waiter.display_name)) {
      changeTab('waiter')
    } else if (payload.data.hookah) {
      changeTab('hookah')
    } else if (payload.data.kitchener) {
      changeTab('kitchener')
    } else if (payload.data.barista) {
      changeTab('barista')
    } else if (payload.data.sommelier) {
      changeTab('sommelier')
    } else if (payload.data.barman) {
      changeTab('barman')
    } else if (payload.data.team) {
      changeTab('team')
    } else {
      changeTab('')
    }

    // Пересчитываем чаевые
    if (Boolean(payload.data.waiter && payload.data.waiter.waiter_status === 'VERIFIED' && (payload.data.waiter.name || payload.data.waiter.display_name)) && payload.data.waiter.card_verification && payload.data.tipsType === 'TAPPER') {
      // Дефолтные чаевые
      let numberPercents = 10
      if (payload.increasedPercentage) {
        numberPercents = 15
      }
      if (payload.increasedPercentageZero) {
        numberPercents = 0
      }
      if (payload.increasedPercentageFive) {
        numberPercents = 5
      }

      const waiterTips = {
        role: 'waiter',
        sum: 49,
        selectedPercent: numberPercents,
        manualTips: false,
        hideActiveStylePercent: true
      }
      if (payload.data.fee_type === 'WITHOUT_FEE') {
        waiterTips.selectedPercent = 12.5
        if (payload.sumOrders && payload.sumOrders >= 392) {
          waiterTips.sum = (payload.sumOrders / 100 * 12.5)
          waiterTips.hideActiveStylePercent = false
        }
      } else if (payload.sumOrders && payload.sumOrders >= 490) {
        waiterTips.sum = (payload.sumOrders / 100 * numberPercents)
        waiterTips.hideActiveStylePercent = false
      }

      // Новая логика для чаевых
      // if (payload.newLogic) {
      //   if (payload.sumOrders <= 500) {
      //     waiterTips.sum = 100
      //     waiterTips.hideActiveStylePercent = true
      //   } else if (payload.sumOrders > 500 && payload.sumOrders <= 1000) {
      //     waiterTips.sum = 200
      //     waiterTips.hideActiveStylePercent = true
      //   }
      // }

      // logic for 0% defaule
      if (numberPercents === 0) {
        waiterTips.sum = 0
        waiterTips.hideActiveStylePercent = false
      }

      changeTips(waiterTips)
    }
  }

  const updateData = (payload: IData) => {
    const { waiter, hookah, kitchener, barista, sommelier, barman, team } = payload

    if (waiter) {
      const active = Boolean(waiter.waiter_status === 'VERIFIED' && (waiter.name || waiter.display_name))
      tips.waiter.active = active
      tips.waiter.name = waiter.display_name && waiter.display_name.length ? waiter.display_name : waiter.name
      tips.waiter.avatar = waiter.avatar
      tips.waiter.purpose = waiter.purpose ?? null
      tips.waiter.sum = active ? tips.waiter.sum : 0
      if (payload.fee_type === 'WITHOUT_FEE') {
        tips.waiter.percents = [0, 7.5, 12.5, 20, 25]
      }
      if (!waiter.card_verification) {
        tips.waiter.sum = 0
      }
    } else {
      tips.waiter.sum = 0
    }

    if (hookah) {
      tips.hookah.active = hookah.active
      tips.hookah.name = hookah.name
      tips.hookah.avatar = hookah.avatar
      tips.hookah.purpose = hookah.purpose ?? null
      tips.hookah.sum = hookah.active ? tips.hookah.sum : 0
    }

    if (kitchener) {
      tips.kitchener.active = kitchener.active
      tips.kitchener.name = kitchener.name
      tips.kitchener.avatar = kitchener.avatar
      tips.kitchener.purpose = kitchener.purpose ?? null
      tips.kitchener.sum = kitchener.active ? tips.kitchener.sum : 0
    }

    if (barista) {
      tips.barista.active = barista.active
      tips.barista.name = barista.name
      tips.barista.avatar = barista.avatar
      tips.barista.purpose = barista.purpose ?? null
      tips.barista.sum = barista.active ? tips.barista.sum : 0
    }

    if (sommelier) {
      tips.sommelier.active = sommelier.active
      tips.sommelier.name = sommelier.name
      tips.sommelier.avatar = sommelier.avatar
      tips.sommelier.purpose = sommelier.purpose ?? null
      tips.sommelier.sum = sommelier.active ? tips.sommelier.sum : 0
    }

    if (barman) {
      tips.barman.active = barman.active
      tips.barman.name = barman.name
      tips.barman.avatar = barman.avatar
      tips.barman.purpose = barman.purpose ?? null
      tips.barman.sum = barman.active ? tips.barman.sum : 0
    }
    if (team) {
      tips.team.active = team.active
      tips.team.name = team.name
      tips.team.avatar = team.avatar
      tips.team.purpose = team.purpose ?? null
      tips.team.sum = team.active ? tips.team.sum : 0
    }
  }

  const changeTips = (payload: IChangeTipsPayload) => {
    const {
      role,
      sum,
      selectedPercent,
      manualTips,
      hideActiveStylePercent,
      percents
    } = payload
    tips[role].sum = Math.round(sum)
    tips[role].selectedPercent = selectedPercent
    tips[role].manualTips = manualTips
    tips[role].hideActiveStylePercent = hideActiveStylePercent
    if (percents !== undefined) {
      tips[role].percents = percents
    }
  }

  const changeDefaultTips = (payload: changeDefaultTips) => {
    tips[payload.role].percents = payload.percents
    tips[payload.role].selectedPercent = payload.selectedPercent
  }

  const setTipsUrl = (url: string) => {
    tipsUrl.value = url
  }

  return {
    tab,
    tips,
    tipsUrl,
    tipsSum,
    changeTab,
    tipsError,
    updateData,
    changeTips,
    setTipsUrl,
    countActiveElements,
    changeDefaultTips,
    changeTipsPersonal,
    firstRecountWaiterTips
  }
})
